import { Fragment } from 'react'
import { Text, View } from 'react-native'

interface CodeEntryDisplayProps {
  digits: string[]
  length: number
  accessibilityLabel: string
  hidden?: boolean
  groupAt?: number
}

export function CodeEntryDisplay({
  digits,
  length,
  accessibilityLabel,
  hidden = false,
  groupAt,
}: CodeEntryDisplayProps) {
  const slots = Array.from({ length }, (_, i) => digits[i] ?? '')
  const activeIndex = digits.length < length ? digits.length : -1

  if (hidden) {
    return (
      <View
        className="w-full flex-row items-center justify-center"
        accessibilityRole="text"
        accessibilityLabel={accessibilityLabel}
      >
        {slots.map((digit, index) => (
          <HiddenSlot key={index} isFilled={digit.length > 0} />
        ))}
      </View>
    )
  }

  return (
    <View
      className="w-full flex-row items-center gap-2"
      accessibilityRole="text"
      accessibilityLabel={accessibilityLabel}
    >
      {slots.map((digit, index) => (
        <Fragment key={index}>
          {groupAt === index ? <Text className="text-2xl font-light text-muted">–</Text> : null}
          <VisibleSlot digit={digit} isActive={activeIndex === index} />
        </Fragment>
      ))}
    </View>
  )
}

function HiddenSlot({ isFilled }: { isFilled: boolean }) {
  return (
    <View className="h-16 flex-1 items-center justify-center">
      <View
        className={`h-5 w-5 rounded-full border-2 ${
          isFilled ? 'border-accent bg-accent' : 'border-border bg-transparent'
        }`}
      />
    </View>
  )
}

function VisibleSlot({ digit, isActive }: { digit: string; isActive: boolean }) {
  return (
    <View
      className={`h-16 flex-1 items-center justify-center rounded-md border ${
        isActive ? 'border-accent' : 'border-border'
      } bg-canvas-primary`}
    >
      <Text className="text-2xl font-semibold text-primary">{digit}</Text>
    </View>
  )
}
